<template>
    <div class="testimonial-section">
        <!-- Comilla de fondo -->
        <div class="quote-background">
            <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.945-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 6.5 10zm11 0c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 17.5 10z"/>
            </svg>
        </div>

        <div class="testimonial-wrapper">
            <div class="testimonial-quote">
                <span class="quote-text fuente-nova">"Un buen servicio no termina cuando un cliente se va."</span>
                <span class="quote-text fuente-nova">Con Efisense Feedback respondemos al instante: si una reseña es negativa, todo el equipo recibe una notificación en tiempo real y puede actuar de inmediato.</span>
                <span class="quote-text fuente-nova">Las reseñas positivas nos permiten reconocer a nuestro talento y seguir elevando nuestro estándar de servicio."</span>
            </div>

            <div class="testimonial-author">
                <div class="company-logo">
                    <img :src="companyLogo" class="img-fluid">
                </div>
                <span class="author-name fuente-nova2">Mario García</span>
                <span class="author-title fuente-nova">Supervisor de Marca – MB Chicken</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TestimonioFeedbackNew',
    data() {
        return {
            companyLogo: require('@/assets/images/mb.png'),
        }
    },
}
</script>

<style lang="css" scoped>
.testimonial-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 40px;
    box-sizing: border-box;
    scroll-snap-align: start;
}

.quote-background {
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translateY(-50%);
    width: 180px;
    height: 180px;
    color: var(--color-1);
    opacity: 0.12;
    z-index: 0;
    pointer-events: none;
}

.quote-background svg {
    width: 100%;
    height: 100%;
}

.testimonial-wrapper {
    max-width: 700px;
    z-index: 1;
}

.testimonial-quote {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.quote-text {
    color: var(--color-3);
    font-size: 23px;
    line-height: 1.4;
    display: block;
}

.testimonial-author {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.author-name {
    color: var(--color-3);
    font-size: 25px;
    line-height: 1.1;
}

.author-title {
    color: var(--color-1);
    font-size: 22px;
    line-height: 1.1;
    margin-top: 5px;
}

.company-logo {
    width: 150px;
    flex-shrink: 0;
}

.company-logo img {
    width: 100%;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .quote-text {
        font-size: 21px;
    }
    .author-name {
        font-size: 23px;
    }
    .author-title {
        font-size: 20px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .testimonial-section {
        height: 100vh;
        min-height: 100vh;
        padding: 20px;
        align-items: center;
        justify-content: center;
    }

    .quote-background {
        width: 100px;
        height: 100px;
        left: 5%;
        top: 20%;
        transform: none;
    }

    .testimonial-wrapper {
        width: 100%;
    }

    .testimonial-quote {
        gap: 15px;
    }

    .quote-text {
        font-size: 17px;
    }

    .testimonial-author {
        margin-top: 30px;
    }

    .testimonial-author {
        justify-content: flex-start;
    }

    .author-name {
        font-size: 18px;
    }

    .author-title {
        font-size: 14px;
    }

    .company-logo {
        width: 35vw;
        max-width: 150px;
    }
}
</style>
